import { render, staticRenderFns } from "./ModelModal.vue?vue&type=template&id=8e644cc4&scoped=true&"
import script from "./ModelModal.vue?vue&type=script&lang=js&"
export * from "./ModelModal.vue?vue&type=script&lang=js&"
import style0 from "./ModelModal.vue?vue&type=style&index=0&id=8e644cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e644cc4",
  null
  
)

export default component.exports